import { useMemo } from "react";
import { useMapLevel } from "@evergis/react";

import { scaleIsVisible } from "../../../evergis/core/scale";
import { useDefaultScaleRange } from "../../../hooks/style/useDefaultScaleRange";
import { LayerInfo } from "../../../interfaces/resourceInfo";

export const useOutOfScale = (layer: LayerInfo): boolean => {
  const mapLevel = useMapLevel();
  const defaultScaleRange = useDefaultScaleRange();

  return useMemo(
    () => layer?.style && !scaleIsVisible(layer.style, mapLevel, defaultScaleRange),
    [defaultScaleRange, layer?.style, mapLevel],
  );
};
